import { Link as RouterLink, LinkProps } from 'react-router-dom';

import { cn } from '@/shared/utils/cn';

export const Link = ({ className, children, ...props }: LinkProps) => {
  return (
    <RouterLink viewTransition className={cn('', className)} {...props}>
      {children}
    </RouterLink>
  );
};
